import axios from 'axios';

const http = axios.create({
  baseURL: process.env.VUE_APP_API_URL || 'https://crm-api.savorbridge.com/api',
  headers: {
    'Content-Type': 'application/json',
    'Accept':'application/json',
  },
});

http.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem('bearer_token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export default http;
